import AutorenewIcon from "@mui/icons-material/Autorenew";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HistoryIcon from "@mui/icons-material/History";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import Person from "@mui/icons-material/Person";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SettingsIcon from "@mui/icons-material/Settings";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  Box,
  Button,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import axios from "axios";
import { allCountries } from "country-telephone-data";
import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getPermissions } from "../store/rootReducer";
import ActionSubscriptionModal from "../components/ActionSubscriptionModal";
import AddClinic from "../components/AddClinic";
import AddKiosk from "../components/AddKiosk";
import CustomButton from "../components/Button";
import ChangePlanPopup from "../components/changePlanPopup";
import SwapPlanPopup from "../components/SwapPlanPopup";
import ConfirmationPopup from "../components/ConfirmationPopup";
import CustomDatePicker from "../components/CustomDatePicker";
import ExpandBox from "../components/ExpandBox";
import InvoiceList from "../components/InvoiceList";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import { useToast } from "../components/Toast";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";

const PAYMENT_STATUS_META = {
  paid: { color: "#2E7D32", bg: "#E8F5E9" },
  partially_paid: { color: "#B85900", bg: "#FFF3E0" },
  initiated: { color: "#616161", bg: "#F5F5F5" },
  failed: { color: "#C62828", bg: "#FFEBEE" },
  refunded: { color: "#1565C0", bg: "#E3F2FD" },
};

// The backend's own nightly sweep is what actually flips status between
// upcoming/active/expired (see runSubscriptionLifecycleSweep) — but that
// only runs once a day, so there's a window right after a start/end date
// passes where sub.status hasn't caught up yet. Re-derive from the dates
// here too so the displayed label is never stale waiting on that cron.
const getEffectiveSubStatus = (sub) => {
  const now = new Date();
  if (sub.status === "active" && new Date(sub.endDate) < now) return "expired";
  if (sub.status === "active" && new Date(sub.startDate) > now) return "upcoming";
  if (sub.status === "upcoming" && new Date(sub.startDate) <= now) return "active";
  return sub.status;
};

const getNextPendingInstallment = (payment) =>
  [...(payment.installments || [])]
    .filter((i) => i.status === "pending")
    .sort((a, b) => a.installmentNo - b.installmentNo)[0] || null;

const DoctorDetail = () => {
  const [isLoader, setIsLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const location = useLocation();
  const Toast = useToast();
  const isMobile = useIsMobile();
  const [FileUpload, setFileUpload] = useState(false);
  const { doctorId, doctorName, docMobile, username } = location.state || {}; // Destructure state data
  const navigate = useNavigate();
  const [isEditable, setIsEditable] = useState(false);
  const [isDocEditable, setDocEditable] = useState(false);
  const [isClinicEditable, setClinicEditable] = useState(false);
  const [isKioskEditable, setKioskEditable] = useState(false);
  const [addKiosk, setAddKiosk] = useState(false);
  const [isAddKioskOpen, setIsAddKioskOpen] = useState(false);
  const [isAddClinicOpen, setIsAddClinicOpen] = useState(false);
  const [showCreateSub, setShowCreateSub] = useState(false);
  const [mode, setMode] = useState("");
  const [plans, setPlans] = useState([]);
  const token = localStorage.getItem("token");
  const [userName, setUsename] = useState(username);
  const [lifecycle, setLifecycle] = useState({});
  const [openPaymentIndex, setOpenPaymentIndex] = React.useState(null);
  // const [Adjustment, setAdjustment] = useState({});
  // const [upgrades, setUpgrades] = useState({});
  const handleOpenAddKioskDialog = () => setIsAddKioskOpen(true);
  const handleOpenAddClinicDialog = () => setIsAddClinicOpen(true);
  const handleOpenSubDialog = () => setShowCreateSub(true);
  const [basePrice, setBasePrice] = useState(null);
  // The renewal's start date should default to the current plan's endDate —
  // the next cycle only makes sense once the current one is actually over.
  const [renewDefaultStartDate, setRenewDefaultStartDate] = useState(null);

  // Admin-only direct edit of a subscription's price/dates (bypasses the
  // usual renew/extend lifecycle actions for one-off corrections).
  const permissions = useSelector(getPermissions) || {};
  const canEditSubscription = !!permissions.subscriptionEdit;
  const [editingSubId, setEditingSubId] = useState(null);
  const [subEditForm, setSubEditForm] = useState({
    price: "",
    startDate: "",
    endDate: "",
    reason: "",
  });

  const handleCloseAddKioskDialog = () => {
    getDoctorDetails(doctorId);
    setIsAddKioskOpen(false);
  };
  const handleCloseAddClinicDialog = () => {
    getDoctorDetails(doctorId);
    setIsAddClinicOpen(false);
  };
  const handleCloseSubModAL = () => {
    getDoctorDetails(doctorId);
    setShowCreateSub(false);
  };
  const handleCloseChangePlan = () => {
    getDoctorDetails(doctorId);
    setOpenChangePlanPopup(false);
    setLifecycle("");
  };
  const handleCloseSwapPlanPopup = () => {
    getDoctorDetails(doctorId);
    setOpenSwapPlanPopup(false);
    setLifecycle("");
  };
  const [clinic, setClinics] = useState([]);
  const [selectedClinicIndex, setSelectedClinicIndex] = useState(0);

  // Select the react-datepicker-wrapper class
  const datePickerWrapper = document.querySelector(".react-datepicker-wrapper");
  const isEngageDetailsPage = location.pathname.startsWith(
    "/dashboard/engage/doctorDetails/",
  );
  if (datePickerWrapper) {
    // Set the width to 100%
    datePickerWrapper.style.width = "100%";
  }

  const [openSections, setOpenSections] = useState({
    docDetails: true,
    cliDetails: false,
    kioDetails: false,
    credentials: false,
    subDetails: false,
    invoices: false,
  });
  const navigateToLogs = (subId) => {
    navigate(`/dashboard/doctor/doctorDetails/${doctorId}/logs/${subId}`, {
      state: { subscriptionId: subId },
    });
  };
  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const Pass = "TemparrarytestPasForNoPassSend";
  const [doctorDetails, setDoctorDetails] = useState({
    name: "",
    countryCode: "",
    mobile: "",
    gender: "",
    engageAccess: "",
  });
  const [Cred, setCred] = useState({
    username: "",
    password: "",
  });
  const [clinicDetails, setClinicDetails] = useState({
    clinicId: "",
    clinicName: "",
    address: "",
    clinicCountryCode: "",
    clinicMobile: "",
    email: "",
    website: "",
    validTill: null,
    city: "",
    state: "",
    country: "",
    mapLink: "",
    mediaDriveLink: "",
  });
  const [subDetails, setSubDetails] = useState([]);
  const [installmentReminder, setInstallmentReminder] = useState(null);
  const reminderShownRef = useRef(false);
  // Per-card expand/collapse override — undefined means "use the status
  // default" (active expanded, everything else collapsed to a summary row).
  const [expandedSubIds, setExpandedSubIds] = useState({});
  const [openCancelPopup, setOpenCancelPopup] = useState(false);
  const [openUnpausePopup, setOpenUnpausePopup] = useState(false);
  const [openChangePlanPopup, setOpenChangePlanPopup] = useState(false);
  const [openSwapPlanPopup, setOpenSwapPlanPopup] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState("");
  const handleCancelClosePopup = () => {
    setOpenCancelPopup(false);
    setOpenUnpausePopup(false);
    setLifecycle("");
  };
  const [logo, setLogo] = useState("");
  const [kioskDetails, setKioskDetails] = useState([]);
  const populateClinicDetails = (clinic, details = {}) => {
    setLogo(clinic.clinicLogo || "");
    setClinicDetails({
      clinicId: clinic._id || "NA",
      clinicName: clinic.name || "No Clinic Name found",
      address: clinic.address || "No address",
      clinicCountryCode: clinic.countryCode || "N/A",
      clinicMobile: clinic.mobile || "No Number Found",
      email: clinic.email || "No email",
      website: details.websiteUrl || clinic.website || "No website found",
      city: clinic.city || "Not found",
      state: clinic.state || "Not found",
      country: clinic.country || "Not found",
      mapLink: clinic.mapsLink || "Not found",
      validTill: formattedDate,
      mediaDriveLink:
        details.mediaDriveLink || clinic.mediaDriveLink || "Not Found",
    });
  };
  let formattedDate = null;
  const getDoctorDetails = async (doctorId) => {
    try {
      setIsLoader(true);
      const details = await apiService.fetchDoctorDetails(doctorId, token);
      const subscription = await apiService.getSubscriptionsByDoctor(
        doctorId,
        token,
      );
      setSubDetails(subscription.data);
      setCred({
        username: details.username,
        password: Pass,
      });

      if (details.validTill) {
        const date = new Date(details.validTill);
        if (!isNaN(date.getTime())) {
          formattedDate = date; // Store as Date object
        } else {
          console.warn("Invalid `validTill` value:", details.validTill);
        }
      } else {
        console.warn("Missing `validTill` value in response");
      }

      const loadedClinics = details.clinics || [];
      setClinics(loadedClinics);

      if (loadedClinics.length > 0) {
        setSelectedClinicIndex(0); // make sure to reset index
        populateClinicDetails(loadedClinics[0], details); // pass full details if needed

        const kiosks = loadedClinics[0]?.kiosk || [];
        setKioskDetails(
          kiosks.map((kiosk) => ({
            kioskId: kiosk._id || "N/A",
            kioskName: kiosk.name || "No Kiosk Name found",
            kioskLocation: kiosk.location || "No location found",
            kioskLanguages: Array.isArray(kiosk.languages)
              ? kiosk.languages.map((lang) => ({
                  title: lang.title || "N/A",
                  value: lang.value || "N/A",
                }))
              : [],
          })),
        );
      }

      //  setKioskId(kiosk._id || "N/A");

      setDoctorDetails({
        name: details.name,
        mobile: details.mobile,
        countryCode: details.countryCode || "NA",
        gender: details.gender || "NA",
        engageAccess: details.engageAccess,
      });

      setLogo(loadedClinics[0]?.clinicLogo || details.logoUrl || "");
    } catch (error) {
      console.error("Error in getDoctorDetails: ", error);
    } finally {
      setIsLoader(false);
    }
  };
  const handleUpdate = async (formData) => {
    try {
      const result = await apiService.updateDoctor(formData, token);
      getDoctorDetails(doctorId);
      return { success: true };
    } catch (err) {
      console.error("Update failed:", err);
      return { success: false, message: err?.message || "Update failed" };
    }
  };
  const getPlans = async () => {
    setIsLoader(true);
    try {
      const plans = await apiService.getPlans(token);
      setPlans(plans.plans);
    } catch (err) {
      console.error("getPlans failed:", err);
    } finally {
      setIsLoader(false);
    }
  };
  useEffect(() => {
    if (doctorId) {
      getDoctorDetails(doctorId);
      getPlans();
    }
  }, [doctorId]);

  // Pops up the first time the Subscription Details section is opened (not
  // on page load, and not again for the rest of this visit) so ops don't
  // forget to come back and mark a pending installment paid once the money
  // actually arrives — reminder, not a confirm-before-action.
  useEffect(() => {
    if (!openSections.subDetails || reminderShownRef.current) return;

    for (const sub of subDetails || []) {
      if (getEffectiveSubStatus(sub) === "expired") continue;
      for (const payment of sub.paymentRecords || []) {
        const next = getNextPendingInstallment(payment);
        if (!next) continue;
        reminderShownRef.current = true;
        setInstallmentReminder({
          paymentId: payment._id,
          installmentNo: next.installmentNo,
          amount: next.amount,
          currency: payment.currency,
          planName: sub.planName || null,
        });
        return;
      }
    }
  }, [openSections.subDetails, subDetails]);

  const handleClinicSaveClick = async () => {
    try {
      setIsLoader(true);
      const formData = new FormData();
      formData.append(
        "doctor",
        JSON.stringify({
          websiteUrl: clinicDetails.website,
          mediaDriveLink: clinicDetails.mediaDriveLink,
          _id: doctorId,
        }),
      );

      formData.append(
        "clinic",
        JSON.stringify({
          name: clinicDetails.clinicName,
          address: clinicDetails.address,
          countryCode: clinicDetails.clinicCountryCode,
          mobile: clinicDetails.clinicMobile,
          email: clinicDetails.email,
          city: clinicDetails.city,
          state: clinicDetails.state,
          country: clinicDetails.country,
          mapsLink: clinicDetails.mapLink,
          _id: clinicDetails.clinicId,
        }),
      );

      if (FileUpload && selectedFile instanceof File) {
        if (
          selectedFile.type === "image/png" ||
          selectedFile.type === "image/jpg" ||
          selectedFile.type === "image/jpeg"
        ) {
          formData.append("clinic_logo", selectedFile);
        } else {
          Toast.error(
            "Invalid file type. Please upload a PNG, JPG, or JPEG image for logo",
          );
          setIsLoader(false);
          return;
        }
      }

      handleUpdate(formData);

      setClinicEditable(false);
      setFileUpload(false);
      setSelectedFile(null);
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message,
      );
      Toast.error("An error occurred while submitting Clinic data!");
    }
  };
  const handleDocSaveClick = async () => {
    try {
      setIsLoader(true);
      const formData = new FormData();
      const doctorData = {
        name: doctorDetails.name,
        countryCode: doctorDetails.countryCode,
        gender: doctorDetails.gender || "",
        validTill: clinicDetails.validTill,
        _id: doctorId,
      };

      if (docMobile !== doctorDetails.mobile) {
        doctorData.mobile = doctorDetails.mobile;
      }

      formData.append("doctor", JSON.stringify(doctorData));

      handleUpdate(formData);

      setDocEditable(false);
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message,
      );
      Toast.error("An error occurred while submitting Doctors data!");
    }
  };
  const handleKioskSaveClick = async () => {
    try {
      setIsLoader(true);

      // Validate kiosk details
      if (!kioskDetails || kioskDetails.length === 0) {
        Toast.error("No kiosk details available.");
        setIsLoader(false);
        return;
      }

      for (const kiosk of kioskDetails) {
        // Validate individual kiosk data
        if (!kiosk.kioskName || !kiosk.kioskLocation || !kiosk.kioskId) {
          Toast.error("Please provide all details for each kiosk.");
          continue; // Skip this kiosk and move to the next
        }

        // Prepare kiosk data
        const kioskData = {
          name: kiosk.kioskName,
          location: kiosk.kioskLocation,
          code: "",
          _id: kiosk.kioskId,
        };

        // Create FormData for each kiosk
        const formData = new FormData();
        formData.append("kiosk", JSON.stringify(kioskData));

        // Make API request for this kiosk
        handleUpdate(formData);
      }

      Toast.success("All kiosk data processed!");
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      console.error("Unexpected error:", error.message);
      Toast.error("An unexpected error occurred!");
    }
  };

  const handleSaveClick = async () => {
    try {
      const formData = new FormData();
      setIsLoader(true);

      const doctorData = {
        _id: doctorId,
      };

      // Only add username if it has changed
      if (userName !== Cred.username) {
        doctorData.username = Cred.username;
      }

      // Only add password if it has changed
      if (Pass !== Cred.password) {
        doctorData.password = Cred.password;
      }

      // Append only the doctor data if it's not empty
      if (Object.keys(doctorData).length > 1) {
        formData.append("doctor", JSON.stringify(doctorData));

        const result = await handleUpdate(formData);
        setIsLoader(false);

        if (result.success) {
          setUsename(Cred.username);
          setIsEditable(false);
          Toast.success("Credentials updated successfully..!");
        } else {
          Toast.error(result.message);
        }
      } else {
        setIsLoader(false);
        Toast.error("No changes to save.");
      }
    } catch (error) {
      setIsLoader(false);
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message,
      );
      Toast.error("An error occurred while submitting Credentials!");
    }
  };

  const handleDoctorChange = (e) => {
    const { name, value } = e.target;
    setDoctorDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };
  const handleClinicChange = (e) => {
    const { name, value } = e.target;
    setClinicDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const handleKioskChange = (event, index) => {
    const { name, value } = event.target;
    setKioskDetails((prevState) => {
      const updatedKiosks = [...prevState];
      updatedKiosks[index][name] = value;
      return updatedKiosks;
    });
  };

  const handleCredChange = (e) => {
    const { name, value } = e.target;
    setCred((prevDetails) => ({ ...prevDetails, [name]: value }));
  };
  const handleDateChange = (date) => {
    setClinicDetails((prevState) => ({
      ...prevState,
      validTill: date, // Store Date object
    }));
  };
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setFileUpload(false);
    } else {
      setFileUpload(true);
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      // Check if the selected file is one of the allowed types
      if (allowedTypes.includes(file.type)) {
        setSelectedFile(file);
      } else {
        // If the file type is not valid, show an error message
        console.error(
          "Invalid file type. Please upload a PNG, JPG, or JPEG image.",
        );
        Toast.error(
          "Invalid file type. Please upload a PNG, JPG, or JPEG image",
        );
      }
    }
  };
  const onclickSettings = (kioskId) => {
    navigate(`/dashboard/engage/doctorDetails/${kioskId}/settings`, {
      state: {
        kioskId: kioskId,
        kioskDetails: kioskDetails,
      },
    });
  };

  const handleCancelConfirm = async (reasonText) => {
    try {
      await apiService.pauseSubscription(token, subscriptionId, reasonText);
      setLifecycle("");
      setOpenCancelPopup(false);
      getDoctorDetails(doctorId);
    } catch (error) {
      console.log("Error in cancel subscription", error);
      Toast.error("An error occurred while cancel subscription!");
    } finally {
      setLifecycle("");
      setOpenCancelPopup(false);
    }
  };
  const handleUnpauseConfirm = async (reasonText) => {
    try {
      await apiService.unpauseSubscription(token, subscriptionId, reasonText);
      setLifecycle("");
      setOpenUnpausePopup(false);
      getDoctorDetails(doctorId);
    } catch (error) {
      console.log("Error in resatrt subscription", error);
      Toast.error("An error occurred while restarting subscription!");
    } finally {
      setLifecycle("");
      setOpenUnpausePopup(false);
    }
  };

  const toDateInputValue = (d) => {
    if (!d) return "";
    const date = new Date(d);
    if (Number.isNaN(date.getTime())) return "";
    return date.toISOString().slice(0, 10);
  };

  const startEditSub = (sub) => {
    setEditingSubId(sub._id);
    setSubEditForm({
      price: String(sub.customPrice ?? sub.planSnapshot?.price ?? ""),
      startDate: toDateInputValue(sub.startDate),
      endDate: toDateInputValue(sub.endDate),
      reason: "",
    });
  };

  const cancelEditSub = () => {
    setEditingSubId(null);
    setSubEditForm({ price: "", startDate: "", endDate: "", reason: "" });
  };

  const saveEditSub = async (sub) => {
    try {
      setIsLoader(true);
      const reason = subEditForm.reason?.trim() || "Admin correction via Subscription Details";
      const newPrice = Number(subEditForm.price);
      const priceChanged =
        !Number.isNaN(newPrice) &&
        newPrice !== (sub.customPrice ?? sub.planSnapshot?.price ?? null);
      const startChanged = subEditForm.startDate && subEditForm.startDate !== toDateInputValue(sub.startDate);
      const endChanged = subEditForm.endDate && subEditForm.endDate !== toDateInputValue(sub.endDate);

      if (priceChanged) {
        await apiService.overridePrice(token, sub._id, newPrice, reason);
      }
      if (startChanged || endChanged) {
        await apiService.updateSubscriptionDates(token, sub._id, {
          startDate: startChanged ? subEditForm.startDate : undefined,
          endDate: endChanged ? subEditForm.endDate : undefined,
          reason,
        });
      }

      Toast.success("Subscription updated successfully!");
      cancelEditSub();
      getDoctorDetails(doctorId);
    } catch (error) {
      console.error("Error updating subscription", error);
      Toast.error("Failed to update subscription");
    } finally {
      setIsLoader(false);
    }
  };

  const handleAction = (action, subID, price, currentEndDate, isExpired) => {
    switch (action) {
      case "renew":
        setSubscriptionId(subID);
        setMode("renew");
        setShowCreateSub(true);
        setLifecycle("");
        setBasePrice(price);
        setRenewDefaultStartDate(currentEndDate || null);
        break;
      case "cancel":
        setSubscriptionId(subID);
        setOpenCancelPopup(true);
        break;
      case "un-pause":
        setSubscriptionId(subID);
        setOpenUnpausePopup(true);
        break;
      case "expire-upgrade":
        console.log("expire temp upgrade");
        break;
      case "reset-cycle":
        console.log("reset-cycle");
        break;

      case "change-plan":
        console.log("subID", subID);
        setSubscriptionId(subID);
        setOpenChangePlanPopup(true);
        console.log("chnage plan");
        break;

      case "swap-plan":
        setSubscriptionId(subID);
        setOpenSwapPlanPopup(true);
        break;

      case "override-price":
        console.log("override price");
        break;

      case "override-quota":
        console.log("ovverride quota");
        break;

      case "extend":
        console.log("extend");
        break;

      case "temporary-upgrade":
        console.log("temp upgrade");
        break;

      case "grant":
        console.log("grant");
        break;

      default:
        break;
    }
  };
  const fileInputRef = useRef(null);
  const [currentSubscriptionId, setCurrentSubscriptionId] = useState(null);

  const handleUploadInvoice = (subscriptionId) => {
    setCurrentSubscriptionId(subscriptionId);

    // always trigger the hidden input
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const uploadInvoice = async (file, subscriptionId) => {
    try {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("invoice", file); // adjust name if backend differs

      const res = await axios.post(
        `${process.env.REACT_APP_API_HOST_URL}/v1/subscription/doctor/${subscriptionId}/upload-invoices`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Toast.success("Invoice uploaded successfully!");
      getDoctorDetails(doctorId);
      setIsLoader(false);
    } catch (error) {
      console.error("Error uploading invoice:", error);
      setIsLoader(true);
      Toast.error("Upload failed");
    }
  };
  const handlePayInstallment = async (paymentId) => {
    try {
      const token = localStorage.getItem("token");

      const response = await apiService.payNextInstallment(paymentId, token);

      console.log("Installment Paid:", response.data);

      // OPTIONAL: reload doctor details after payment
      getDoctorDetails(doctorId);

      toast.success("Installment paid successfully!");
    } catch (err) {
      console.error("Error paying installment:", err);
      toast.error("Payment failed!");
    }
  };

  return (
    <div>
      <Box sx={{ padding: isMobile ? 1 : 3 }}>
        <Title icon={<Person />} text={doctorName || "Doctor Details"} />

        <ExpandBox
          title="Doctor Details"
          isOpen={openSections.docDetails}
          toggle={() => toggleSection("docDetails")}
        >
          <Collapse in={openSections.docDetails}>
            {!isDocEditable ? (
              <CustomButton
                text="Edit"
                onClick={() => setDocEditable(true)}
                width={isMobile ? "110px" : "150px"}
              />
            ) : (
              <Box sx={{ display: "flex", gap: 2 }}>
                <CustomButton
                  backgroundColor="#CCD3DA"
                  color="#000"
                  hoverColor="#A9A9A9"
                  text="Cancel"
                  onClick={() => setDocEditable(false)} // Use arrow function
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Save"
                  onClick={handleDocSaveClick}
                  width={isMobile ? "110px" : "150px"}
                />
              </Box>
            )}

            <Grid container spacing={2} marginBottom={1} marginTop={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Name"
                  name="name"
                  value={doctorDetails.name}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputProps={{
                    readOnly: !isDocEditable, // If not editable, make the field read-only
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  select
                  label="Country Code"
                  name="countryCode"
                  value={doctorDetails.countryCode}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true, // This ensures the label appears above the TextField
                  }}
                  InputProps={{
                    readOnly: !isDocEditable, // If not editable, make the field read-only
                  }}
                >
                  {allCountries.map((country) => (
                    <MenuItem
                      key={country.dialCode + country.iso2}
                      value={`+${country.dialCode}`}
                    >
                      {country.name} (+{country.dialCode})
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Mobile"
                  name="mobile"
                  value={doctorDetails.mobile}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputProps={{
                    readOnly: !isDocEditable, // If not editable, make the field read-only
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Gender"
                  name="gender"
                  value={doctorDetails.gender}
                  onChange={handleDoctorChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true, // This ensures the label appears above the TextField
                  }}
                  InputProps={{
                    readOnly: !isDocEditable, // If not editable, make the field read-only
                  }}
                >
                  {[
                    { code: "male", label: "Male" },
                    { code: "female", label: "Female" },
                  ].map((option) => (
                    <MenuItem key={option.code} value={option.code}>
                      {option.label} {/* Only show label */}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomDatePicker
                  selectedDate={clinicDetails.validTill}
                  handleDateChange={handleDateChange}
                  isDocEditable={isDocEditable}
                  label={"Valid Till"}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  label="Doctor Id"
                  name="doctorId"
                  value={doctorId}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            </Grid>
          </Collapse>
        </ExpandBox>

        <ExpandBox
          title="Clinic Details"
          isOpen={openSections.cliDetails}
          toggle={() => toggleSection("cliDetails")}
        >
          {clinic.length > 1 && (
            <TextField
              select
              label="Select Clinic"
              value={selectedClinicIndex}
              onChange={(e) => {
                const index = parseInt(e.target.value, 10);
                setSelectedClinicIndex(index);
                populateClinicDetails(clinic[index]);
                const kiosks = clinic[index]?.kiosk || [];
                setKioskDetails(
                  kiosks.map((kiosk) => ({
                    kioskId: kiosk._id || "N/A",
                    kioskName: kiosk.name || "No Kiosk Name found",
                    kioskLocation: kiosk.location || "No location found",
                    kioskLanguages: Array.isArray(kiosk.languages)
                      ? kiosk.languages.map((lang) => ({
                          title: lang.title || "N/A",
                          value: lang.value || "N/A",
                        }))
                      : [],
                  })),
                );
              }}
              sx={{ marginBottom: 2, width: "100%" }}
            >
              {clinic.map((clinic, index) => (
                <MenuItem key={clinic.name + index} value={index}>
                  {clinic.name || `Clinic ${index + 1}`}
                </MenuItem>
              ))}
            </TextField>
          )}

          <Collapse in={openSections.cliDetails}>
            {!isClinicEditable ? (
              <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                <CustomButton
                  text="Edit"
                  onClick={() => setClinicEditable(true)}
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Add Clinic"
                  onClick={handleOpenAddClinicDialog}
                  width="150px"
                />
              </Box>
            ) : (
              <Box sx={{ display: "flex", gap: 2 }}>
                <CustomButton
                  backgroundColor="#CCD3DA"
                  color="#000"
                  hoverColor="#A9A9A9"
                  text="Cancel"
                  onClick={() => {
                    setClinicEditable(false);
                    setFileUpload(false);
                    setSelectedFile(null);
                  }}
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Save"
                  onClick={handleClinicSaveClick}
                  width={isMobile ? "110px" : "150px"}
                />
              </Box>
            )}
            <Grid container spacing={2} marginBottom={1} marginTop={1}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Clinic Name"
                    name="clinicName"
                    value={clinicDetails.clinicName}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    select
                    label="Country Code"
                    name="clinicCountryCode"
                    value={clinicDetails.clinicCountryCode}
                    onChange={handleClinicChange}
                    fullWidth
                    InputLabelProps={{
                      shrink: true, // This ensures the label appears above the TextField
                    }}
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  >
                    {allCountries.map((country) => (
                      <MenuItem
                        key={country.dialCode + country.iso2}
                        value={`+${country.dialCode}`}
                      >
                        {country.name} (+{country.dialCode})
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Mobile"
                    name="clinicMobile"
                    value={clinicDetails.clinicMobile}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Address"
                    name="address"
                    value={clinicDetails.address}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="City"
                    name="city"
                    value={clinicDetails.city}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="State"
                    name="state"
                    value={clinicDetails.state}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Country"
                    name="country"
                    value={clinicDetails.country}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Map Link"
                    name="mapLink"
                    value={clinicDetails.mapLink}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    name="email"
                    value={clinicDetails.email}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Website"
                    name="website"
                    value={clinicDetails.website}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Media Drive Link"
                    name="mediaDriveLink"
                    value={clinicDetails.mediaDriveLink}
                    onChange={handleClinicChange}
                    fullWidth
                    InputProps={{
                      readOnly: !isClinicEditable, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    label="Clinic Id"
                    name="clinicId"
                    value={clinicDetails.clinicId}
                    fullWidth
                    InputProps={{
                      readOnly: true, // If not editable, make the field read-only
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ fontSize: "0.75rem", color: "text.secondary", mb: 1 }}>
                    Clinic logo
                  </Box>
                  <img
                    src={logo}
                    alt="Clinic Logo"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      objectFit: "contain",
                      borderRadius: "8px",
                      display: "block",
                      marginBottom: "8px",
                    }}
                  />
                  {isClinicEditable && (
                    <input
                      accept="image/*"
                      type="file"
                      onChange={handleImageUpload}
                      style={{ display: "block" }}
                    />
                  )}
                </Grid>
              </Grid>
          </Collapse>
        </ExpandBox>

        <ExpandBox
          title="Air Details"
          isOpen={openSections.kioDetails}
          toggle={() => toggleSection("kioDetails")}
        >
          {clinic.length > 1 && (
            <TextField
              select
              label="Select Clinic"
              value={selectedClinicIndex}
              onChange={(e) => {
                const index = parseInt(e.target.value, 10);
                setSelectedClinicIndex(index);
                populateClinicDetails(clinic[index]);
                const kiosks = clinic[index]?.kiosk || [];
                setKioskDetails(
                  kiosks.map((kiosk) => ({
                    kioskId: kiosk._id || "N/A",
                    kioskName: kiosk.name || "No Kiosk Name found",
                    kioskLocation: kiosk.location || "No location found",
                    kioskLanguages: Array.isArray(kiosk.languages)
                      ? kiosk.languages.map((lang) => ({
                          title: lang.title || "N/A",
                          value: lang.value || "N/A",
                        }))
                      : [],
                  })),
                );
              }}
              sx={{ marginBottom: 2, width: "100%" }}
            >
              {clinic.map((clinic, index) => (
                <MenuItem key={clinic.name + index} value={index}>
                  {clinic.name || `Clinic ${index + 1}`}
                </MenuItem>
              ))}
            </TextField>
          )}

          <Collapse in={openSections.kioDetails}>
            {!isKioskEditable ? (
              <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                <CustomButton
                  text="Edit"
                  onClick={() => setKioskEditable(true)}
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Add Kiosk"
                  onClick={handleOpenAddKioskDialog}
                  width="150px"
                />
              </Box>
            ) : (
              <Box sx={{ display: "flex", gap: 2 }}>
                <CustomButton
                  backgroundColor="#CCD3DA"
                  color="#000"
                  hoverColor="#A9A9A9"
                  text="Cancel"
                  onClick={() => setKioskEditable(false)} // Use arrow function
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Save"
                  onClick={handleKioskSaveClick}
                  width={isMobile ? "110px" : "150px"}
                />
              </Box>
            )}
            <Grid container spacing={2} marginBottom={1} marginTop={1}>
              {kioskDetails.map((kiosk, index) => (
                <React.Fragment key={kiosk.kioskId || index}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={`Air Name ${index + 1}`}
                      name="kioskName"
                      value={kiosk.kioskName}
                      onChange={(e) => handleKioskChange(e, index)}
                      fullWidth
                      InputProps={{
                        readOnly: !isKioskEditable,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      label={`Location ${index + 1}`}
                      name="kioskLocation"
                      value={kiosk.kioskLocation}
                      onChange={(e) => handleKioskChange(e, index)}
                      fullWidth
                      InputProps={{
                        readOnly: !isKioskEditable,
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={1}
                    container
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Tooltip title="Settings">
                      <IconButton
                        onClick={() => onclickSettings(kiosk.kioskId)}
                      >
                        <SettingsIcon style={{ fontSize: 40 }} />{" "}
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      label={`Kiosk Id ${index + 1} `}
                      name="kioskId"
                      value={kiosk.kioskId}
                      fullWidth
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </Collapse>
        </ExpandBox>
        <ExpandBox
          title="Login Credentials"
          isOpen={openSections.credentials}
          toggle={() => toggleSection("credentials")}
        >
          <Collapse in={openSections.credentials}>
            {!isEditable ? (
              <CustomButton
                text="Edit"
                onClick={() => setIsEditable(true)}
                width={isMobile ? "110px" : "150px"}
              />
            ) : (
              <Box sx={{ display: "flex", gap: 2 }}>
                <CustomButton
                  backgroundColor="#CCD3DA"
                  color="#000"
                  text="Cancel"
                  hoverColor="#A9A9A9"
                  onClick={() => setIsEditable(false)} // Use arrow function
                  width={isMobile ? "110px" : "150px"}
                />
                <CustomButton
                  text="Save"
                  onClick={handleSaveClick}
                  width={isMobile ? "110px" : "150px"}
                />
              </Box>
            )}
            <Grid container spacing={2} marginBottom={1} marginTop={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Username"
                  name="username"
                  value={Cred.username}
                  fullWidth
                  onChange={handleCredChange}
                  InputProps={{
                    readOnly: !isEditable, // If not editable, make the field read-only
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Password"
                  name="password"
                  value={Cred.password}
                  onChange={handleCredChange}
                  type="password"
                  fullWidth
                  InputProps={{
                    readOnly: !isEditable, // If not editable, make the field read-only
                  }}
                />
              </Grid>
            </Grid>
          </Collapse>
        </ExpandBox>
        <ExpandBox
          title="Subscription Details"
          isOpen={openSections.subDetails}
          toggle={() => toggleSection("subDetails")}
        >
          {subDetails.length === 0 ? (
            doctorDetails.engageAccess === "admin" ? (
              <CustomButton
                text="Create"
                onClick={() => {
                  setMode("create");
                  handleOpenSubDialog();
                }}
                width={isMobile ? "110px" : "150px"}
              />
            ) : (
              <div>Not an admin</div>
            )
          ) : null}

          <Collapse in={openSections.subDetails}>
            <Grid container spacing={2} marginY={2}>
              {(() => {
                const sorted = [...(subDetails || [])].sort((a, b) => {
                  // Active always leads, upcoming trails behind everything else
                  // that's already had its turn (paused/expired).
                  const ORDER = { active: 0, paused: 1, expired: 2, upcoming: 3 };
                  return (
                    (ORDER[getEffectiveSubStatus(a)] ?? 4) -
                    (ORDER[getEffectiveSubStatus(b)] ?? 4)
                  );
                });
                // An expired plan that's been superseded (a newer active/
                // upcoming/paused one already exists) is just noise — hide
                // it. Only show an expired card when it's the doctor's sole
                // subscription, so that history doesn't just disappear.
                const hasNonExpired = sorted.some(
                  (s) => getEffectiveSubStatus(s) !== "expired",
                );
                const visibleSubs = hasNonExpired
                  ? sorted.filter((s) => getEffectiveSubStatus(s) !== "expired")
                  : sorted;
                return visibleSubs;
              })().map((sub, index) => {
                let statusColor = "";
                let statusBgColor = "";

                // Backend only flips status to "expired" as a side effect of
                // createSubscription when a NEW subscription is later created
                // for this doctor — a lapsed plan otherwise keeps whatever

                const now = new Date();
                const effectiveStatus = getEffectiveSubStatus(sub);
                // Active is the one people actually need to see, so it opens
                // expanded by default; anything else (upcoming/paused/expired)
                // starts as a compact summary row until explicitly opened.
                const isSubExpanded =
                  expandedSubIds[sub._id] ?? effectiveStatus === "active";
                const toggleSubExpanded = () =>
                  setExpandedSubIds((prev) => ({
                    ...prev,
                    [sub._id]: !isSubExpanded,
                  }));

                // Determine color based on effectiveStatus
                switch (effectiveStatus.toLowerCase()) {
                  case "active":
                    statusColor = "#4CAF50";
                    statusBgColor = "#E8F5E9";
                    break;
                  case "paused":
                    statusColor = "#FF9800";
                    statusBgColor = "#FFF3E0";
                    break;
                  case "expired":
                    statusColor = "#F44336";
                    statusBgColor = "#FFEBEE";
                    break;
                  case "upcoming":
                    statusColor = "#2196F3";
                    statusBgColor = "#E3F2FD";
                    break;
                  default:
                    statusColor = "#FF9800";
                    statusBgColor = "#FFF3E0";
                }

                return (
                  <Grid item xs={12} key={sub._id || index}>
                    <Box
                      sx={{
                        border: `2px solid ${statusColor}`,
                        borderRadius: 2,
                        p: { xs: 2, sm: 3 },
                        mb: 3,
                        pt: { xs: 4.5, sm: 5 },
                        position: "relative", // Crucial for positioning the status label
                        // Muted like a background browser tab for a plan that hasn't
                        // started yet, but only while collapsed — once opened to
                        // read the details, it should look like any other card.
                        bgcolor:
                          effectiveStatus === "upcoming" && !isSubExpanded
                            ? "#EDEDED"
                            : "transparent",
                      }}
                    >
                      {/* --- Status Label Corner --- */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          transform: "translate(-5px, -20px)", // Adjust to sit right on the corner
                          backgroundColor: statusBgColor,
                          color: statusColor,
                          fontWeight: "bold",
                          fontSize: "0.8rem",
                          px: 1.5,
                          py: 0.5,
                          borderRadius: "4px 0 4px 0",
                          borderRight: `1px solid ${statusColor}`,
                          borderBottom: `1px solid ${statusColor}`,
                          textTransform: "uppercase",
                          zIndex: 2,
                        }}
                      >
                        {effectiveStatus}
                        <Box
                          sx={{
                            px: 1,
                            py: 0.2,
                            fontSize: "0.65rem",
                            borderRadius: "3px",
                            fontWeight: 700,
                          }}
                        >
                          {sub.type}
                        </Box>
                      </Box>
                      {/* --------------------------- */}

                      {/* Collapsed summary + expand toggle — keeps a
                          non-active plan to one compact row until opened. */}
                      <Box
                        onClick={toggleSubExpanded}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          userSelect: "none",
                        }}
                      >
                        {!isSubExpanded && (
                          <Typography sx={{ fontSize: "0.9rem", color: "text.secondary" }}>
                            {sub.planName}
                            {sub.startDate &&
                              ` • Starts ${new Date(sub.startDate).toLocaleDateString()}`}
                          </Typography>
                        )}
                        <ExpandMoreIcon
                          sx={{
                            ml: "auto",
                            color: "grey.500",
                            transform: isSubExpanded ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 200ms ease",
                          }}
                        />
                      </Box>

                      <Collapse in={isSubExpanded} timeout="auto" unmountOnExit>

                      <Grid container spacing={2}>
                        {canEditSubscription && (
                          <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                              {editingSubId === sub._id ? (
                                <>
                                  <CustomButton
                                    text="Save"
                                    onClick={() => saveEditSub(sub)}
                                    backgroundColor="#4CAF50"
                                    hoverColor="#43A047"
                                    color="#fff"
                                  />
                                  <CustomButton
                                    text="Cancel"
                                    onClick={cancelEditSub}
                                    backgroundColor="#CCD3DA"
                                  />
                                </>
                              ) : (
                                <Button
                                  variant="outlined"
                                  size="small"
                                  startIcon={<EditIcon />}
                                  sx={{ borderRadius: 2, textTransform: "none" }}
                                  onClick={() => startEditSub(sub)}
                                >
                                  Edit
                                </Button>
                              )}
                            </Box>
                          </Grid>
                        )}

                        {/* Plan Name */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Plan Name"
                            value={sub.planName}
                            fullWidth
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Status"
                            value={effectiveStatus}
                            fullWidth
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        {/* Billing Cycle */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Billing Cycle"
                            value={sub.planSnapshot.billingCycle || ""}
                            fullWidth
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>

                        {/* Price — customPrice (e.g. a discounted order price)
                        overrides the plan's own canonical price when set;
                        nullish coalescing so a genuine 0 isn't treated as unset. */}
                        <Grid item xs={12} sm={6}>
                          {editingSubId === sub._id ? (
                            <TextField
                              label={`Price (${sub.planSnapshot?.currency || ""})`}
                              type="number"
                              value={subEditForm.price}
                              fullWidth
                              onChange={(e) =>
                                setSubEditForm((prev) => ({ ...prev, price: e.target.value }))
                              }
                            />
                          ) : (
                            <TextField
                              label="Price"
                              value={`${sub.planSnapshot?.currency || ""} ${
                                sub.customPrice ?? sub.planSnapshot?.price ?? ""
                              }`}
                              fullWidth
                              InputProps={{ readOnly: true }}
                            />
                          )}
                        </Grid>

                        {/* Start Date */}
                        <Grid item xs={12} sm={6}>
                          {editingSubId === sub._id ? (
                            <TextField
                              label="Start Date"
                              type="date"
                              value={subEditForm.startDate}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) =>
                                setSubEditForm((prev) => ({ ...prev, startDate: e.target.value }))
                              }
                            />
                          ) : (
                            <TextField
                              label="Start Date"
                              value={new Date(sub.startDate).toLocaleDateString(
                                "en-IN",
                              )}
                              fullWidth
                              InputProps={{ readOnly: true }}
                            />
                          )}
                        </Grid>

                        {/* End Date */}
                        <Grid item xs={12} sm={6}>
                          {editingSubId === sub._id ? (
                            <TextField
                              label="End Date"
                              type="date"
                              value={subEditForm.endDate}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) =>
                                setSubEditForm((prev) => ({ ...prev, endDate: e.target.value }))
                              }
                            />
                          ) : (
                            <TextField
                              label="End Date"
                              value={new Date(sub.endDate).toLocaleDateString(
                                "en-IN",
                              )}
                              fullWidth
                              InputProps={{ readOnly: true }}
                            />
                          )}
                        </Grid>

                        {editingSubId === sub._id && (
                          <Grid item xs={12}>
                            <TextField
                              label="Reason for change (optional)"
                              value={subEditForm.reason}
                              fullWidth
                              onChange={(e) =>
                                setSubEditForm((prev) => ({ ...prev, reason: e.target.value }))
                              }
                            />
                          </Grid>
                        )}

                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Installment validity End Date"
                            value={new Date(
                              sub.planDisableDate,
                            ).toLocaleDateString("en-IN")}
                            fullWidth
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>

                        {/* Features */}
                        <Grid item xs={12}>
                          <TextField
                            label="Features"
                            value={
                              sub?.planSnapshot?.features?.join(", ") || ""
                            }
                            multiline
                            fullWidth
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>

                        {/* Current Scans */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Current Usage (Scans)"
                            value={sub.currentUsage?.scans}
                            fullWidth
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>

                        {/* Effective Limits */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Effective limits (Scans)"
                            value={
                              sub?.effectiveLimits?.scans === -1
                                ? "Unlimited"
                                : (sub?.effectiveLimits?.scans ?? "")
                            }
                            fullWidth
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file && currentSubscriptionId) {
                              uploadInvoice(file, currentSubscriptionId);
                            }
                            e.target.value = ""; // reset for same file upload again
                          }}
                        />

                        {/* Manage Subscription */}
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              p: 2.5,
                              borderRadius: 2,
                              border: "1px solid #E0E0E0",

                              mt: 2,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: 600,

                                mb: 0.5,
                              }}
                            >
                              Manage Subscription
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              Renew, pause or change this subscription's plan.
                            </Typography>

                            {sub.status === "paused" ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                  flexWrap: "wrap",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ fontStyle: "italic" }}
                                >
                                  Disabled as not Active
                                </Typography>
                                {!subDetails.some(
                                  (item) =>
                                    item._id !== sub._id &&
                                    item.status === "active" &&
                                    new Date(item.startDate) <= now &&
                                    new Date(item.endDate) > now,
                                ) && (
                                  <CustomButton
                                    text="Restart Subscripton"
                                    onClick={() =>
                                      handleAction("un-pause", sub._id)
                                    }
                                  />
                                )}
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 1.5,
                                }}
                              >
                                <Button
                                  variant="contained"
                                  size="small"
                                  startIcon={<AutorenewIcon />}
                                  sx={{ borderRadius: 2, textTransform: "none" }}
                                  onClick={() => {
                                    setLifecycle((prev) => ({
                                      ...prev,
                                      [sub._id]: "renew",
                                    }));
                                    handleAction(
                                      "renew",
                                      sub._id,
                                      sub.planSnapshot?.price,
                                      sub.endDate,
                                      effectiveStatus === "expired",
                                    );
                                  }}
                                >
                                  Renew
                                </Button>

                                {effectiveStatus === "active" && (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="warning"
                                    startIcon={<PauseCircleOutlineIcon />}
                                    sx={{ borderRadius: 2, textTransform: "none" }}
                                    onClick={() => {
                                      setLifecycle((prev) => ({
                                        ...prev,
                                        [sub._id]: "cancel",
                                      }));
                                      handleAction(
                                        "cancel",
                                        sub._id,
                                        sub.planSnapshot?.price,
                                        sub.endDate,
                                        effectiveStatus === "expired",
                                      );
                                    }}
                                  >
                                    Pause
                                  </Button>
                                )}

                                {effectiveStatus === "active" && (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<TrendingUpIcon />}
                                    sx={{ borderRadius: 2, textTransform: "none" }}
                                    onClick={() => {
                                      setLifecycle((prev) => ({
                                        ...prev,
                                        [sub._id]: "change-plan",
                                      }));
                                      handleAction(
                                        "change-plan",
                                        sub._id,
                                        sub.planSnapshot?.price,
                                        sub.endDate,
                                        effectiveStatus === "expired",
                                      );
                                    }}
                                  >
                                    Upgrade Plan
                                  </Button>
                                )}

                                {subDetails.length > 1 && (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<SwapHorizIcon />}
                                    sx={{ borderRadius: 2, textTransform: "none" }}
                                    onClick={() => {
                                      setLifecycle((prev) => ({
                                        ...prev,
                                        [sub._id]: "swap-plan",
                                      }));
                                      handleAction(
                                        "swap-plan",
                                        sub._id,
                                        sub.planSnapshot?.price,
                                        sub.endDate,
                                        effectiveStatus === "expired",
                                      );
                                    }}
                                  >
                                    Swap Plan
                                  </Button>
                                )}
                              </Box>
                            )}

                              {/* Adjustments */}
                              {/* <Grid item xs={12} md={4}>
        <TextField
          select
          disabled={sub.status !== "active"}
          label="Adjustments"
          value={adjustment[sub._id] || ""}
          fullWidth
          onChange={(e) => {
            const value = e.target.value;

            setAdjustment((prev) => ({
              ...prev,
              [sub._id]: value,
            }));

            handleAction(value, sub._id);
          }}
        >
          <MenuItem value="override-price">Override Price</MenuItem>
          <MenuItem value="override-quota">Override Quota</MenuItem>
          <MenuItem value="extend">Extend</MenuItem>
        </TextField>
      </Grid> */}

                              {/* Upgrades (Commented out) */}
                              {/* <Grid item xs={12} md={4}>
        <TextField
          select
          disabled={sub.status !== "active"}
          label="Upgrades & Maintenance"
          value={upgrades[sub._id] || ""}
          fullWidth
          onChange={(e) => {
            const value = e.target.value;

            setUpgrades((prev) => ({
              ...prev,
              [sub._id]: value,
            }));

            handleAction(value, sub._id);
          }}
        >
          <MenuItem value="temporary-upgrade">Temp Upgrade</MenuItem>
          <MenuItem value="expire-upgrade">Expire Upgrade</MenuItem>
          <MenuItem value="grant">Grant Scans</MenuItem>
          <MenuItem value="reset-cycle">Reset Cycle</MenuItem>
        </TextField>
      </Grid> */}
                          </Box>
                        </Grid>
                      </Grid>
                      {/* Payments Section (Collapsed List Only) */}
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            border: "1px solid #E0E0E0",
                            mt: 3,
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 600, mb: 2 }}
                          >
                            Payments
                          </Typography>
                          <Grid container spacing={2}>
                            {sub.paymentRecords.length === 0 ? (
                              <Grid item xs={12}>
                                <Typography>No payments found.</Typography>
                              </Grid>
                            ) : (
                              sub.paymentRecords.map((payment, idx) => {
                                const isOpen = openPaymentIndex === idx;
                                const statusMeta = PAYMENT_STATUS_META[payment.status] || PAYMENT_STATUS_META.initiated;

                                return (
                                  <Grid item xs={12} sm={6} key={payment._id}>
                                    {/* Header */}
                                    <Box
                                      onClick={() =>
                                        setOpenPaymentIndex(isOpen ? null : idx)
                                      }
                                      sx={{
                                        cursor: "pointer",
                                        p: 1.5,
                                        borderRadius: 2,
                                        border: `1px solid ${statusMeta.color}55`,
                                        backgroundColor: statusMeta.bg,
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        rowGap: 0.5,
                                        gap: 1,
                                      }}
                                    >
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
                                        <Typography sx={{ fontWeight: 600 }}>
                                          Payment {idx + 1}
                                        </Typography>
                                        <Chip
                                          size="small"
                                          label={payment.status.replace(/_/g, " ")}
                                          sx={{
                                            fontWeight: 700,
                                            textTransform: "uppercase",
                                            fontSize: "0.65rem",
                                            color: statusMeta.color,
                                            backgroundColor: `${statusMeta.color}22`,
                                          }}
                                        />
                                      </Box>
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Typography sx={{ fontWeight: 600, color: "text.secondary" }}>
                                          {payment.currency} {payment.amount}
                                        </Typography>
                                        <ExpandMoreIcon
                                          sx={{
                                            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                                            transition: "transform 0.15s ease",
                                          }}
                                        />
                                      </Box>
                                    </Box>

                                    {/* Dropdown Content */}
                                    <Collapse in={isOpen}>
                                      <Box
                                        sx={{
                                          p: 2,
                                          border: "1px solid #eee",
                                          borderTop: "none",
                                          borderRadius: "0 0 8px 8px",
                                          mt: -0.5,
                                          pt: 2.5,
                                        }}
                                      >
                                        <Typography sx={{ mb: 1 }}>
                                          <b>Amount: </b>
                                          {payment.currency} {payment.amount}
                                        </Typography>

                                        {payment.isInstallment && (
                                          <>
                                            <Typography
                                              sx={{ fontWeight: 600, mb: 1 }}
                                            >
                                              Installments:
                                            </Typography>

                                            {/* 🔹 INSTALLMENT LIST — compact
                                            content-sized pills, not Grid
                                            columns, so they don't get
                                            stretched/wrapped tall in this
                                            already-narrow nested box. Shown
                                            before the Pay button so you see
                                            what's paid before acting on it. */}
                                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
                                              {payment.installments.map(
                                                (inst) => {
                                                  const isPaid =
                                                    inst.status === "paid";
                                                  const meta = isPaid
                                                    ? {
                                                        color: "#2E7D32",
                                                        bg: "#E8F5E9",
                                                        Icon: CheckCircleOutlineIcon,
                                                      }
                                                    : {
                                                        color: "#B85900",
                                                        bg: "#FFF3E0",
                                                        Icon: ScheduleIcon,
                                                      };
                                                  const tooltip = isPaid
                                                    ? `Paid${
                                                        inst.paidAt
                                                          ? " on " + new Date(inst.paidAt).toLocaleDateString("en-IN")
                                                          : ""
                                                      }`
                                                    : "Pending";

                                                  return (
                                                    <Box
                                                      key={inst._id}
                                                      title={tooltip}
                                                      sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 0.75,
                                                        px: 1.5,
                                                        py: 0.75,
                                                        borderRadius: 5,
                                                        border: `1px solid ${meta.color}55`,
                                                        backgroundColor: meta.bg,
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <meta.Icon sx={{ fontSize: 16, color: meta.color }} />
                                                      <Typography
                                                        sx={{
                                                          fontSize: "0.78rem",
                                                          fontWeight: 700,
                                                          color: meta.color,
                                                        }}
                                                      >
                                                        #{inst.installmentNo}: {payment.currency} {inst.amount}
                                                      </Typography>
                                                    </Box>
                                                  );
                                                },
                                              )}
                                            </Box>

                                            {/* 🔹 PAY NEXT PENDING INSTALLMENT */}
                                            {payment.installments.some(
                                              (i) => i.status === "pending",
                                            ) && (
                                              <CustomButton
                                                onClick={() =>
                                                  handlePayInstallment(
                                                    payment._id,
                                                  )
                                                }
                                                text="Pay Next Installment"
                                                width="auto"
                                                sx={{
                                                  padding: "6px 16px",
                                                  fontSize: "0.78rem",
                                                  fontWeight: 700,
                                                  borderRadius: "6px",
                                                  boxShadow: "none",
                                                }}
                                              />
                                            )}
                                          </>
                                        )}
                                      </Box>
                                    </Collapse>
                                  </Grid>
                                );
                              })
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            sx={{ mt: "20px", display: "flex", flexWrap: "wrap", gap: 1.5 }}
                          >
                            <CustomButton
                              startIcon={<UploadFileIcon />}
                              text="Upload Invoice"
                              width="auto"
                            
                              sx={{
                                padding: "8px 20px",
                                fontSize: "0.85rem",
                                fontWeight: 600,
                                borderRadius: "8px",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                                transition: "transform 0.2s",
                                "&:active": { transform: "scale(0.98)" },
                              }}
                              onClick={() => handleUploadInvoice(sub._id)}
                            />

                            <CustomButton
                              startIcon={<HistoryIcon />}
                              width="auto"
                              sx={{
                                padding: "8px 20px",
                                fontSize: "0.85rem",
                                fontWeight: 600,
                                borderRadius: "8px",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                                transition: "transform 0.2s",
                                "&:active": { transform: "scale(0.98)" },
                              }}
                              text="Check Logs"
                              onClick={() => navigateToLogs(sub._id)}
                            />
                          </Grid>
                        </Box>
                      </Grid>
                      </Collapse>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Collapse>
        </ExpandBox>

        <ExpandBox
          title="Invoices"
          isOpen={openSections.invoices}
          toggle={() => toggleSection("invoices")}
        >
          <InvoiceList subDetails={subDetails} />
        </ExpandBox>
        <AddKiosk
          open={isAddKioskOpen}
          onClose={handleCloseAddKioskDialog}
          clinicId={clinicDetails.clinicId}
        />
        <AddClinic
          open={isAddClinicOpen}
          onClose={handleCloseAddClinicDialog}
          doctorId={doctorId}
        />

        <ActionSubscriptionModal
          open={showCreateSub}
          onClose={handleCloseSubModAL}
          token={token}
          doctorId={doctorId}
          clinicDetails={clinic}
          plans={plans}
          subscriptionId={subscriptionId}
          mode={mode}
          baseRenewPrice={basePrice}
          renewDefaultStartDate={renewDefaultStartDate}
        />
        <ConfirmationPopup
          reason={"Pausing Reason"}
          open={openCancelPopup}
          onClose={handleCancelClosePopup}
          onConfirm={(reasonText) => handleCancelConfirm(reasonText)}
        />
        <ConfirmationPopup
          reason={"Restart Reason"}
          open={openUnpausePopup}
          onClose={handleCancelClosePopup}
          onConfirm={(reasonText) => handleUnpauseConfirm(reasonText)}
        />

        <Dialog
          open={Boolean(installmentReminder)}
          onClose={() => setInstallmentReminder(null)}
          fullWidth
          maxWidth="xs"
          PaperProps={{ sx: { borderRadius: 3, width: "100%" } }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              fontWeight: 700,
              fontSize: 20,
              color: "#B85900",
              textAlign: "center",
              pb: 1,
            }}
          >
            <NotificationsActiveIcon sx={{ color: "#B85900" }} />
            Payment Reminder
          </DialogTitle>
          <DialogContent sx={{ px: 3, pb: 1, textAlign: "center" }}>
            <Typography variant="body1" color="textSecondary">
              Installment #{installmentReminder?.installmentNo} (
              {installmentReminder?.currency} {installmentReminder?.amount})
              {installmentReminder?.planName
                ? ` for ${installmentReminder.planName}`
                : ""}{" "}
              is due. Mark it as paid once the payment is received.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", p: 2.5, gap: 1.5 }}>
            <CustomButton
              text="Later"
              variant="outlined"
              color="#5A5A5A"
              startIcon={<ScheduleIcon />}
              width="130px"
              onClick={() => setInstallmentReminder(null)}
            />
            <CustomButton
              text="Mark as Paid"
              backgroundColor="#2E7D32"
              hoverColor="#1B5E20"
              color="#fff"
              startIcon={<CheckCircleOutlineIcon />}
              width="170px"
              onClick={async () => {
                await handlePayInstallment(installmentReminder.paymentId);
                setInstallmentReminder(null);
              }}
            />
          </DialogActions>
        </Dialog>

        <ChangePlanPopup
          open={openChangePlanPopup}
          onClose={handleCloseChangePlan}
          token={token}
          subscriptionId={subscriptionId}
          plans={plans}
          currentPlanId={
            subDetails?.find((s) => s._id === subscriptionId)?.planId
          }
          selectedRegion={
            subDetails?.find((s) => s._id === subscriptionId)?.planSnapshot
              ?.geo || "IN"
          }
        />

        <SwapPlanPopup
          open={openSwapPlanPopup}
          onClose={handleCloseSwapPlanPopup}
          token={token}
          subscriptionId={subscriptionId}
          otherSubscriptions={subDetails.filter(
            (sub) => sub._id !== subscriptionId,
          )}
        />
      </Box>

      {isLoader && <PageLoader />}
    </div>
  );
};

export default DoctorDetail;
